import { useState, type FormEvent } from 'react';
import { useAuth } from '../contextos/AuthContext';
import { InterruptorTema } from '../componentes/InterruptorTema';

export function Login() {
  const { iniciarSesion } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const alEnviar = async (evento: FormEvent) => {
    evento.preventDefault();
    setError(null);
    setEnviando(true);

    try {
      await iniciarSesion(email, password);
    } catch (fallo) {
      setError(fallo instanceof Error ? fallo.message : 'No se pudo iniciar sesión.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, position: 'relative', zIndex: 1 }}>
      <div style={{ position: 'absolute', top: 24, right: 24 }}>
        <InterruptorTema />
      </div>

      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 28, justifyContent: 'center' }}>
          <div className="brand-logo-icon" style={{ width: 44, height: 44, fontSize: 19 }}>L</div>
          <div>
            <div className="brand-name" style={{ fontSize: 22 }}>
              LEXI<span>CORE</span>
            </div>
            <div className="brand-subtitle" style={{ letterSpacing: 0 }}>CRM de licitaciones</div>
          </div>
        </div>

        <form className="panel" onSubmit={alEnviar} style={{ padding: 28 }}>
          <div className="form-group" style={{ marginBottom: 16 }}>
            <label htmlFor="email">Correo electrónico</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(evento) => setEmail(evento.target.value)}
              autoComplete="username"
              required
              autoFocus
            />
          </div>

          <div className="form-group" style={{ marginBottom: 20 }}>
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(evento) => setPassword(evento.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          {error && (
            <div
              role="alert"
              style={{
                background: 'var(--accent-red-soft)',
                color: 'var(--accent-red)',
                padding: '11px 14px',
                borderRadius: 'var(--radius-sm)',
                fontSize: 12.5,
                marginBottom: 16,
                lineHeight: 1.5,
              }}
            >
              {error}
            </div>
          )}

          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={enviando}>
            {enviando ? 'Entrando…' : 'Entrar'}
          </button>
        </form>

        <p style={{ textAlign: 'center', fontSize: 11, color: 'var(--text-muted)', marginTop: 20 }}>
          © 2026 LEXICORE LABS SYSTEM LIMITADA
        </p>
      </div>
    </div>
  );
}
